<template lang="pug">
  LenderPlanExpander(
    v-bind="{ logoSvg, typeLabel, name, plans, merchantId, description, color, enrollmentLink, readMoreLink }"
    :active="active"
  )
</template>

<script>
import LenderPlanExpander from '@/components/LenderPlanExpander'
import { fortiva } from 'Helpers/lenders.js'
const { logoSvg, typeLabel, name, description, color, enrollmentLink, readMoreLink } = fortiva

export default {
  name: 'fortiva-plan-expander',
  props: {
    merchantId: String,
    active: {
      type: Boolean,
      default: null
    }
  },
  components: {
    LenderPlanExpander,
  },
  data() {
    return {
      logoSvg,
      typeLabel,
      name,
      color,
      description,
      enrollmentLink,
      readMoreLink,
      plans: [],
    }
  },
}
</script>
